module.exports = __webpack_public_path__ + "img/Avanzado.2463f3b7.png";